package one.healthium.profile.ui.update_height

sealed interface UpdateHeightEvent {
    data object OnHeightUpdated : UpdateHeightEvent
}